import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { LEGACY_QUOTE_PATHS, getQuoteStepPath } from 'services/conlicitaseg_flow';

// routes/index.tsx não usa <Switch>: cada redirect precisa de um <Route exact> próprio
const LegacyQuoteRedirects: React.FC = () => (
  <>
    {Object.entries(LEGACY_QUOTE_PATHS).map(([path, step]) => (
      <Route
        key={path}
        path={path}
        exact
        render={({ location }) => (
          <Redirect
            to={{
              pathname: getQuoteStepPath(step),
              search: location.search,
              hash: location.hash,
            }}
          />
        )}
      />
    ))}
  </>
);

export default LegacyQuoteRedirects;
